<template>
  <footer class="app-footer">
    <button v-if="showEndGame" class="btn btn-end-game" @click="$emit('end-game')">Spel beëindigen</button>
    <button v-if="showBack" class="btn btn-back" @click="$emit('back')">{{ backLabel }}</button>
    <button
      v-if="showContinue"
      class="btn btn-continue"
      :disabled="!canContinue"
      @click="$emit('continue')"
    >
      {{ continueLabel }}
    </button>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  emits: ['continue', 'back', 'end-game'],
  props: {
    continueLabel: {
      type: String,
      default: 'Volgende'
    },
    canContinue: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: false
    },
    showEndGame: {
      type: Boolean,
      default: false
    },
    backLabel: {
      type: String,
      default: 'Terug'
    },
    showContinue: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.app-footer {
  display: flex;
  flex-shrink: 0;
  gap: 0.5rem;
  padding: 0.65rem 1rem;
  border-top: 1px solid #aac8aa;
  background-color: #c8e0c8;
}

.btn {
  flex: 1;
  padding: 0.75rem;
  font-size: 1rem;
  font-family: inherit;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  touch-action: manipulation;
}

.btn-end-game {
  background: transparent;
  color: #c0392b;
  border: 2px solid #c0392b;
  flex: 0 0 auto;
  padding-left: 1.1rem;
  padding-right: 1.1rem;
}
.btn-end-game:active { opacity: 0.75; }

.btn-back {
  background: transparent;
  color: #2c3e50;
  border: 2px solid #2c3e50;
  flex: 0 0 auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.btn-back:active { opacity: 0.75; }

.btn-continue {
  background-color: #2c3e50;
  color: #fff;
}
.btn-continue:active { opacity: 0.85; }
.btn-continue:disabled { background-color: #a0a0a0; cursor: not-allowed; }

@media (hover: hover) {
  .btn-continue:hover:not(:disabled) { opacity: 0.9; }
  .btn-back:hover { background: rgba(44, 62, 80, 0.05); }
  .btn-end-game:hover { background: rgba(192, 57, 43, 0.05); }
}
</style>
